module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_1.ccd977f5.png";